import { render, staticRenderFns } from "./WallImageBlock.vue?vue&type=template&id=675ce710"
import script from "./WallImageBlock.vue?vue&type=script&lang=js"
export * from "./WallImageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports